import React, { useState } from 'react';
import { Row, Col, Button, Form, Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './HeroSection.css';
import LanguageSelectionModal from '../Language selection/LanguageSelectionModal';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationArrow } from '@fortawesome/free-solid-svg-icons';


const HeroSection: React.FC = () => {

  const [modalShow, setModalShow] = useState(false);

  const handleShow = () => setModalShow(true);
  const handleClose = () => setModalShow(false);

  return (
    <div className="heroSection">
      <div className="w-100 heroContainer">
        <Row className="container-fluid w-100">
          <Col md={6} className="textArea">
            <h3 className='authorName'>महाकविश्रीसोमदेवभट्टविरचितः</h3>
            <h1 className="title">कथासरित्सागरः</h1>
            <p className="subtitle">
            The ocean of story, translation of Somadeva's Katha sarit sagara
            </p>
          </Col>
        </Row>
      </div>
      <div className="dummy">
      <Row className="dotSection">
        <span>
          <span className="dot">.</span>
          <span className="dot">.</span>
          <span className="dot">.</span>
        </span>
      </Row>
      <p className='optionDescription'>Choose your preferred language for a personalized reading experience</p>
        <div className= 'languageoption'>
          <div style={{width:"100%", textAlign:"center"}}>
          <Link to="/content/sanskrit" className='langlink'>
          <span className='langnavigate' ><span>संस्कृत (मूलम्)</span><span className='navigateicon'><FontAwesomeIcon icon={faLocationArrow} size='xl'/></span></span>
          </Link>
          </div>
          <div style={{width:"100%", textAlign:"center"}}>
          <Link to="/content/english" className='langlink'>
          <span className='langnavigate'><span>English (Translation)</span><span className='navigateicon'><FontAwesomeIcon icon={faLocationArrow} size='xl'/></span></span>
          </Link>
          </div>
        </div>
        <div style={{display:"flex", justifyContent:"center", width:"100%", marginTop:"10px", marginBottom:"10px"}}>
          <Link to="/combined" className='langlink'>
            <span className='langnavigate'><span>संस्कृत-English </span><span className='navigateicon'><FontAwesomeIcon icon={faLocationArrow} size='xl'/></span></span>
            </Link>
        </div>
      </div>
      <Row className="separatorRow">
        <hr />
      </Row>
      <Row className="aboutSection">
        <h3 style={{ marginBottom: '20px' }}>About</h3>
        <p className="aboutText">
        Kathāsaritsāgara, written by Somadeva in the 11th century, is a renowned Sanskrit work. It is a retelling of the ancient text Bṛhatkathā, originally composed by Guṇāḍhya in the now-lost Paiśācī language. The Kathāsaritsāgara is a vast collection of countless stories, spread across 18 sections (called lambakas). Within these stories, gods, kings, common people, sages, and demons appear in various forms. This epic primarily explores themes of philosophy, morality, and a wide range of folklore.
        </p>
        <p className="aboutText">
        The stories in the Kathāsaritsāgara reveal various aspects of courage, love, and wisdom. The narrative style is both simple and engaging, allowing readers to gain a vivid glimpse into ancient Indian life. Through this work, Indian folklore, cultural traditions, and the deeper meanings of human existence are beautifully portrayed. Kathāsaritsāgara is not only an entertaining piece of literature but also a priceless treasure of Indian storytelling heritage.
        </p>
      </Row>
      <Row className="separatorRow">
        <hr />
      </Row>
      <Row className="featuredSection">
        <h4 style={{ marginLeft: '60px' }}>Key Highlights</h4>
        <Row style={{ padding: '40px' }}>
          <Col md={4} className="featuredItem">
           
            <p className="featuredText">Vast Collection of Stories</p>
            <span className="featuredSubText">
            The Kathasaritsagara is a massive compilation of interlinked tales, featuring a complex structure of stories within stories. It primarily revolves around the adventures of Prince Naravahanadatta, but it includes a wide range of other narratives, showcasing the richness of ancient Indian folklore and mythology.
            </span>
          </Col>
          <Col md={4} className="featuredItem">
            
            <p className="featuredText">Cultural and Moral Insights</p>
            <span className="featuredSubText">
            The work offers a deep reflection of the social, cultural, and moral values of ancient India. Through its diverse characters and scenarios, it conveys lessons on virtues like bravery, loyalty, love, and wisdom, making it both entertaining and instructive.
            </span>
          </Col>
          <Col md={4} className="featuredItem">
            
            <p className="featuredText">Literary Influence</p>
            <span className="featuredSubText">
            The Kathasaritsagara has had a significant impact on Indian and world literature. It is based on the now-lost Brihatkatha and has inspired numerous adaptations, translations, and retellings, cementing its place as a cornerstone of classical Indian
            </span>
          </Col>
        </Row>
      </Row>
      <Row className="separatorRow">
        <hr />
      </Row>
      <Row className="typesOfContentSection">
        <Row style={{ textAlign: 'center' }}>
          <h2>Types of content</h2>
          <p>The Kathasaritsagara contains various types of content, including:</p>
        </Row>
        <Row>
          <Col>
            <Row>
              <h5>Mythological Tales</h5>
              <p className="parabelowspacefortypes">
              Stories of gods, goddesses, and celestial beings that explore themes of divinity and the supernatural. These tales often involve moral and ethical lessons.
              </p>
              <h5>Folk Tales</h5>
              <p className="parabelowspacefortypes">
              Narratives rooted in popular folklore, depicting everyday life, moral dilemmas, and cultural practices. These stories are rich in local traditions and customs.
              </p>
              <h5>Adventure Stories</h5>
              <p className="parabelowspacefortypes">
              The central narrative follows Prince Naravahanadatta's journey, filled with trials, quests, and encounters with magical creatures. These adventures showcase bravery, wisdom, and romance.
              </p>
            </Row>
          </Col>
          <Col>
            <Row>
              <h5>Romantic Tales</h5>
              <p className="parabelowspacefortypes">
              Stories of love and relationships, including romantic entanglements and courtly love, reflecting the cultural and societal norms of the time.
              </p>
              <h5>Moral Fables</h5>
              <p className="parabelowspacefortypes">
              Short stories with clear moral messages or lessons, often featuring allegorical elements that impart wisdom and ethical guidance.
              </p>
              <h5>Legends and Historical Accounts</h5>
              <p className="parabelowspacefortypes">
              Narratives that blend historical facts with fictional elements, providing insights into the ancient world and its legendary figures.
              </p>
            </Row>
          </Col>
        </Row>
      </Row>
      <Row className="separatorRow">
        <hr />
      </Row>
      <Row className="contactUsSection">
        <h1>Contact Us</h1>
        <p>examplecompanyemail@gmail.com</p>
      </Row>
      <footer className="footer">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-auto">
              <a href="#" style={{ color: '#fff', margin: '0 10px' }}>
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="#" style={{ color: '#fff', margin: '0 10px' }}>
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#" style={{ color: '#fff', margin: '0 10px' }}>
                <i className="fab fa-twitter"></i>
              </a>
            </div>
            <div className="row justify-content-center mt-3">
          <div className="col-auto">
            <p className='footerText' >Terms of Use · Privacy Policy</p>
            <p className='footerText'>© 2024 Company name</p>
          </div>
          </div>
          </div>
        </div>
      </footer>
      <LanguageSelectionModal show={modalShow} handleClose={handleClose} />
    </div>
  );
};

export default HeroSection;
